import React, { useState, useEffect } from "react";

import Button from "./base/Button";

const baseStyle = {
  backdropFilter: "blur(3px)",
  height: "100%",
  backgroundColor: "#0009",
  opacity: 0,
};

/**
 * Blurred overlay that can fade in and out.
 * @param {{
 *  show?: boolean,
 *  children?: function | ReactElement,
 *  durationInMs?: number,
 *  styleOverride?: CSSOM
 * }} props
 */
const BlurredOverlay = ({ show, children, durationInMs = 300, styleOverride = {} }) => {
  const styleWTransition = {
    ...baseStyle,
    ...styleOverride,
    transition: `opacity ${durationInMs / 1000}s ease`,
  };
  const [showState, setShowState] = useState(show);
  const [opacity, setOpacity] = useState(show ? 1 : 0);

  const hide = () => setShowState(false);
  const animateIn = () => setTimeout(() => setOpacity(1), 0);
  const close = () =>
    new Promise((resolve) => {
      setOpacity(0);
      setTimeout(() => {
        hide();
        resolve();
      }, durationInMs);
    });

  // trigger animate in/out process.
  useEffect(() => {
    if (showState !== show) {
      show ? setShowState(show) : setOpacity(0);
    }
  }, [show, showState]);

  // animate in on showState true.
  useEffect(() => {
    showState && animateIn();
  }, [showState]);

  // animate out and unmount children after animation is done.
  useEffect(() => {
    !opacity && setTimeout(hide, durationInMs);
  }, [opacity]);

  const style = { ...styleWTransition, ...(opacity ? { opacity: 1 } : {}) };

  return showState ? (
    <div id="blurred-overlay" style={style}>
      {typeof children === "function" ? children(close) : children}
    </div>
  ) : null;
};

export default BlurredOverlay;
